import { t } from 'localization/utils/t';

const TP = 'shared.enums.category';

export const CATEGORY_HIERARCHY = {
  sneakers: {
    basketball: {
      value: t(`${TP}.basketball`, 'Basketball'),
      TK: 'basketball',
      TP,
    },
    boots: {
      value: t(`${TP}.boots`, 'Boots'),
      TK: 'boots',
      TP,
    },
    cleats: {
      value: t(`${TP}.cleats`, 'Cleats'),
      TK: 'cleats',
      TP,
    },
    lifestyle: {
      value: t(`${TP}.lifestyle`, 'Lifestyle'),
      TK: 'lifestyle',
      TP,
    },
    running: {
      value: t(`${TP}.running`, 'Running'),
      TK: 'running',
      TP,
    },
    sandals: {
      value: t(`${TP}.sandals`, 'Sandals'),
      TK: 'sandals',
      TP,
    },
    skateboarding: {
      value: t(`${TP}.skateboarding`, 'Skateboarding'),
      TK: 'skateboarding',
      TP,
    },
  },
  apparel: {
    bottoms: {
      value: t(`${TP}.bottoms`, 'Bottoms'),
      TK: 'bottoms',
      TP,
    },
    dresses: {
      value: t(`${TP}.dresses`, 'Dresses'),
      TK: 'dresses',
      TP,
    },
    outerwear: {
      value: t(`${TP}.outerwear`, 'Outerwear'),
      TK: 'outerwear',
      TP,
    },
    swimwear: {
      value: t(`${TP}.swimwear`, 'Swimwear'),
      TK: 'swimwear',
      TP,
    },
    tops: {
      value: t(`${TP}.tops`, 'Tops'),
      TK: 'tops',
      TP,
    },
  },
};

export const ROBUST_TITLE_TEXT_FOR_SUBCATEGORIES = {
  bottoms: {
    value: t(`${TP}.bottoms`, 'jeans, pants, shorts, and more'),
    TK: 'bottoms',
    TP,
  },
  outerwear: {
    value: t(`${TP}.outerwear`, 'blazers, jackets, coats, and more'),
    TK: 'outerwear',
    TP,
  },
  tops: {
    value: t(`${TP}.tops`, 't-shirts, hoodies, sweatshirts, and more'),
    TK: 'tops',
    TP,
  },
};

export const PLP_SUBCATEGORIES = new Set([
  'basketball',
  'boots',
  'cleats',
  'lifestyle',
  'running',
  'sandals',
  'skateboarding',
  'bottoms',
  'dresses',
  'outerwear',
  'swimwear',
  'tops',
]);
